<h2 mat-dialog-title>
    {{ isEdit ? "Update School Details" : "Create School Details" }}
  </h2>
<button type="button" class="btn btn-link modal-close" (click)="cancel()">
    <svg width="24" height="24"
        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</button>
<div class="mat-account-wrapper p-0 ms-0">
    <div class="content-box non-tab edit-school-detail-tab p-4 mb-0 pb-0">
        <div [formGroup]="schoolForm">

            <div class="row my-2">
                <div class="col-sm-6">
                  <div class="mb-0">
                     <div class="d-flex">
                        <mat-label class="black-text fs-14 mb-1">School Code</mat-label>
                        <mat-icon matTooltip= "Clients school code used by their organisation's data."
                          class="fs-22 ms-2">info</mat-icon>
                      </div>
                    <input type="text" formControlName="id" class="form-control" [required]="true" [readOnly]="!canEditCodes"
                      [class.is-invalid]="
                      schoolForm.get('id')!.invalid &&
                      schoolForm.get('id')!.touched" />
                  </div>
                  <div *ngIf="
                    (schoolForm.get('id')!.invalid &&
                    schoolForm.get('id')!.touched) ||
                    schoolForm.get('id')!.dirty">
                    <small *ngIf="schoolForm.get('id')!.errors?.['required']" class="text-danger fs-13">
                      School Code is required
                    </small>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="mb-0">
                    <div class="d-flex">
                        <mat-label class="black-text fs-14 mb-1">School Reference</mat-label>
                        <mat-icon matTooltip= "Deesha internal school reference."
                          class="fs-22 ms-2">info</mat-icon>
                      </div>
                    <input type="text" formControlName="myReferenceSchoolCode" class="form-control" [required]="true" [readOnly]="!canEditCodes"
                      [class.is-invalid]="
                      schoolForm.get('myReferenceSchoolCode')!.invalid &&
                      schoolForm.get('myReferenceSchoolCode')!.touched" />
                  </div>
                  <div *ngIf="
                    (schoolForm.get('myReferenceSchoolCode')!.invalid &&
                    schoolForm.get('myReferenceSchoolCode')!.touched) ||
                    schoolForm.get('myReferenceSchoolCode')!.dirty">
                    <small *ngIf="schoolForm.get('myReferenceSchoolCode')!.errors?.['required']" class="text-danger fs-13">
                      School Reference is required
                    </small>
                  </div>
                </div>
                
                <div *ngIf="schoolData.clientAccountId == 0" class="col-sm-6">
                    <div class="mb-4 mat-account-selectoption">
                      <div class="d-flex">
                        <mat-label class="black-text fs-14 mb-1">Assign Account Admin</mat-label>
                        <mat-icon matTooltip= "Assign an Account Admin for the School you are creating"
                          class="fs-22 ms-2">info</mat-icon>
                      </div>
                      <mat-form-field>
                        <mat-select [required]="true" formControlName="assignedAccountAdmin" [class.is-invalid]="
                            schoolForm.get('assignedAccountAdmin')!.invalid &&
                            schoolForm.get('assignedAccountAdmin')!.touched">
                          @for (accountAdmin of accountAdminList; track accountAdmin) {
                          <mat-option [value]="accountAdmin">{{
                            accountAdmin.firstName?.concat(" " + accountAdmin.lastName || "")
                            }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <div *ngIf="
                          (schoolForm.get('assignedAccountAdmin')!.invalid &&
                          schoolForm.get('assignedAccountAdmin')!.touched) ||
                          schoolForm.get('assignedAccountAdmin')!.dirty">
                        <small *ngIf="schoolForm.get('assignedAccountAdmin')!.errors?.['required']"
                          class="text-danger fs-13">Account Admin is required</small>
                      </div>
                    </div>
                  </div>
              </div>

            <div class="row my-2">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">School Name</span>
                        <input type="text" [required]="true" formControlName="schoolName" class="form-control"
                            [readOnly]="!(schoolForm.get('schoolId')!.value == 0 || canEditCodes)" [class.is-invalid]="
                            schoolForm.controls['schoolName'].invalid &&
                            schoolForm.controls['schoolName'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.controls['schoolName'].invalid &&
                schoolForm.controls['schoolName'].touched) ||
                schoolForm.controls['schoolName'].dirty">
                        <small *ngIf="schoolForm.controls['schoolName'].errors?.['required']" class="text-danger fs-13">
                            School Name is required
                        </small>
                        <small *ngIf="schoolForm.controls['schoolName'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid School Name
                        </small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">Location</span>
                        <input type="text" [required]="true" formControlName="location" class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['location'].invalid &&
                    schoolForm.controls['location'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.controls['location'].invalid &&
                schoolForm.controls['location'].touched) ||
                schoolForm.controls['location'].dirty">
                        <small *ngIf="schoolForm.controls['location'].errors?.['required']" class="text-danger fs-13">
                            Location is required
                        </small>
                        <small *ngIf="schoolForm.controls['location'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid Location
                        </small>
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                        <span class="black-text fs-14 mb-1">Total number of users to be created</span>
                        <mat-icon class="ms-2 fs-22" matTooltip="Provide the number of school users to be created under this school">info</mat-icon>
                    </div>
                        <input type="number" min="1" [required]="true" formControlName="numberOfSchoolUser"
                            class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [class.is-invalid]="
                    schoolForm.controls['numberOfSchoolUser'].invalid &&
                    schoolForm.controls['numberOfSchoolUser'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['numberOfSchoolUser'].invalid &&
                    schoolForm.controls['numberOfSchoolUser'].touched) ||
                    schoolForm.controls['numberOfSchoolUser'].dirty">
                        <small *ngIf="schoolForm.controls['numberOfSchoolUser'].errors?.['required']"
                            class="text-danger fs-13">Total number of users to be created is required</small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                        <span class="black-text fs-14 mb-1">School Capacity</span>
                        <mat-icon matTooltip="Enter the capacity of your school" class="ms-2 fs-22">info</mat-icon>
                        </div>
                        <input type="number" min="1" [required]="true" formControlName="schoolCapacity"
                            class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [class.is-invalid]="
                    schoolForm.controls['schoolCapacity'].invalid &&
                    schoolForm.controls['schoolCapacity'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['schoolCapacity'].invalid &&
                    schoolForm.controls['schoolCapacity'].touched) ||
                    schoolForm.controls['schoolCapacity'].dirty">
                        <small *ngIf="schoolForm.controls['schoolCapacity'].errors?.['required']"
                            class="text-danger fs-13">School Capacity is required</small>
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                        <span class="black-text fs-14 mb-1">Headcount of School</span>
                        <mat-icon matTooltip="Enter the total head count of school" class="ms-2 fs-22">info</mat-icon>
                        </div>
                        <input type="number" min="1" [required]="true" formControlName="headcountOfSchool"
                            class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [class.is-invalid]="
                    schoolForm.controls['headcountOfSchool'].invalid &&
                    schoolForm.controls['headcountOfSchool'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['headcountOfSchool'].invalid &&
                    schoolForm.controls['headcountOfSchool'].touched) ||
                    schoolForm.controls['headcountOfSchool'].dirty">
                        <small *ngIf="schoolForm.controls['headcountOfSchool'].errors?.['required']"
                            class="text-danger fs-13">Headcount of School is required</small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                        <span class="black-text fs-14 mb-1">Number of Non-Teaching Staff</span>
                    </div>
                        <input type="number" min="1" [required]="true" formControlName="numberOfNonTeachingStaff"
                            class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [class.is-invalid]="
                    schoolForm.controls['numberOfNonTeachingStaff'].invalid &&
                    schoolForm.controls['numberOfNonTeachingStaff'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['numberOfNonTeachingStaff'].invalid &&
                    schoolForm.controls['numberOfNonTeachingStaff'].touched) ||
                    schoolForm.controls['numberOfNonTeachingStaff'].dirty">
                        <small *ngIf="schoolForm.controls['numberOfNonTeachingStaff'].errors?.['required']"
                            class="text-danger fs-13">Number of Non-Teaching Staff is required</small>
                    </div>
                </div>
            </div>

            <div class="row my-3">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                        <span class="black-text fs-14 mb-1">Number of Teaching Staff</span>
                       </div>
                        <input type="number" min="1" [required]="true" formControlName="numberOfTeachingStaff"
                            class="form-control" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [class.is-invalid]="
                    schoolForm.controls['numberOfTeachingStaff'].invalid &&
                    schoolForm.controls['numberOfTeachingStaff'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['numberOfTeachingStaff'].invalid &&
                    schoolForm.controls['numberOfTeachingStaff'].touched) ||
                    schoolForm.controls['numberOfTeachingStaff'].dirty">
                        <small *ngIf="schoolForm.controls['numberOfTeachingStaff'].errors?.['required']"
                            class="text-danger fs-13">Number of Teaching Staff is required</small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Curriculum</span>
                            <mat-icon matTooltip="Enter the curriculum followed by the school" class="ms-2 fs-22">info</mat-icon>
                        </div>
                        <input type="text" [required]="true" formControlName="curriculum" class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['curriculum'].invalid &&
                    schoolForm.controls['curriculum'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.get('curriculum')!.invalid &&
                schoolForm.get('curriculum')!.touched) ||
                schoolForm.get('curriculum')!.dirty">
                        <small *ngIf="schoolForm.controls['curriculum'].errors?.['required']" class="text-danger fs-13">
                            Curriculum is required
                        </small>
                        <small *ngIf="schoolForm.controls['curriculum'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid Curriculum
                        </small>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                            <span class="black-text fs-14 mb-1">School Type</span>
                            <mat-icon matTooltip="Enter the school type" class="ms-2 fs-22">info</mat-icon>
                          </div>
                        <input type="text" [required]="true" formControlName="schoolType" class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['schoolType'].invalid &&
                    schoolForm.controls['schoolType'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.controls['schoolType'].invalid &&
                schoolForm.controls['schoolType'].touched) ||
                schoolForm.controls['schoolType'].dirty">
                        <small *ngIf="schoolForm.controls['schoolType'].errors?.['required']" class="text-danger fs-13">
                            School Type is required
                        </small>
                        <small *ngIf="schoolForm.controls['schoolType'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid School Type
                        </small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">Address</span>
                        <input type="text" [required]="true" formControlName="address" class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['address'].invalid &&
                    schoolForm.controls['address'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.controls['address'].invalid &&
                schoolForm.controls['address'].touched) ||
                schoolForm.controls['address'].dirty">
                        <small *ngIf="schoolForm.controls['address'].errors?.['required']" class="text-danger fs-13">
                            Address is required
                        </small>
                        <small *ngIf="schoolForm.controls['address'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid Address
                        </small>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Local Authority</span>
                            <mat-icon matTooltip="Enter the local authority with respect to your school" class="ms-2 fs-22">info</mat-icon>
                        </div>
                        <input type="text" [required]="true" formControlName="localAuthority" class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['localAuthority'].invalid &&
                    schoolForm.controls['localAuthority'].touched" />
                    </div>
                    <div *ngIf="
                (schoolForm.controls['localAuthority'].invalid &&
                schoolForm.controls['localAuthority'].touched) ||
                schoolForm.controls['localAuthority'].dirty">
                        <small *ngIf="schoolForm.controls['localAuthority'].errors?.['required']" class="text-danger fs-13">
                            Local Authority is required
                        </small>
                        <small *ngIf="schoolForm.controls['localAuthority'].errors?.['pattern']" class="text-danger fs-13">
                            Please provide a valid Local Authority
                        </small>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">ID: URN/DfE Number/UKPRN</span>
                        <input type="text" [required]="true" formControlName="schoolRegistrationId"
                            class="form-control"
                            [class.is-invalid]="
                    schoolForm.controls['schoolRegistrationId'].invalid &&
                    schoolForm.controls['schoolRegistrationId'].touched" />
                    </div>
                    <div *ngIf="
                    (schoolForm.controls['schoolRegistrationId'].invalid &&
                    schoolForm.controls['schoolRegistrationId'].touched) ||
                    schoolForm.controls['schoolRegistrationId'].dirty">
                        <small *ngIf="schoolForm.controls['schoolRegistrationId'].errors?.['required']"
                            class="text-danger fs-13">ID: URN/DfE Number/UKPRN is required</small>
                    </div>
                </div>
            </div>

            <div class="row my-2">
                <div class="col-sm-6">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">Notes</span>
                        <textarea class="form-control" formControlName="notes" rows="3">
                </textarea>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-0">
                        <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Upload</span>
                            <mat-icon matTooltip="Attach documents related to school" class="ms-2 fs-22">info</mat-icon>
                        </div>
                        <div class="mt-0 px-3 py-3 custom-file-input">
                            <div class="file-input-wrapper">
                                <span class="file-name">{{ selectedFileCount > 0 ? selectedFileCount + ' file(s) selected' : 'Click to upload' }}</span>
                                <input multiple hidden type="file" #editSchoolFileInput (change)="onFileSelected($event)" />
                                <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                                    (click)="uploadFromLocal($event)">
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-end">
          <button type="button" class="btn theme-btn-outline px-5"
          (click)="cancel()">Cancel</button>
          <button type="button" class="btn theme-btn px-5 ms-3"
          [disabled]="schoolForm.invalid" (click)="updateSchool()">Update</button>
        </div>
    </div>
</div>